import values from 'lodash/fp/values'
import PropTypes from 'prop-types'


const constants = {
    DEFAULT: '',
    ERROR: 'Submit/SEND_CHALLENGE_ERROR',
    PENDING: 'Submit/SEND_CHALLENGE_PENDING',
    SUCCESS: 'Submit/SEND_CHALLENGE_SUCCESS'
}

export const types = PropTypes.oneOf(values(constants))

export default constants
